import React from "react";
import { useTable } from "react-table";
import PensionValuesHeader from "./PensionValuesHeader/PensionValuesHeader";
import tableDotStatus1 from "../../../../assets/images/tableDotStatus1.svg";
import tableDotStatus2 from "../../../../assets/images/tableDotStatus2.svg";
import tableDotStatus3 from "../../../../assets/images/tableDotStatus3.svg";

import "./PensionValuesTable.scss";
import { useTranslation } from "react-i18next";


function Table({ columns, data }) {
  
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  // Render the UI for your table
  return (
    <>
      <div className="pension-values-table desktop-da">
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(
                  (column) =>
                    !column.hideHeader && (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    )
                )}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows && rows.sort((firstDate, secondDate) => Date.parse(firstDate.original.firstInsuranceMonth) < Date.parse(secondDate.original.firstInsuranceMonth) ? 1 : -1).map((row, i) => {
              if(row.original.isBalanceTypePension === 0) return;
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>
                        {cell.render("Cell")}{" "}
                        {(cell.column.Header !== "שם המעסיק" && cell.column.Header !== "اسم المشغل")&& "₪"}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="mobile-table mobile-da">
        <div {...getTableBodyProps()}>
          {rows.map((row, i) => {
            if(row.original.isBalanceTypePension === 0) return;


              prepareRow(row);
              return (
                <div {...row.getRowProps()}>
                  <div className="row-title">{row?.values?.employerName}</div>
                  <div className="d-flex row-table">
                    {row.cells.map((cell) => {
                      return (
                        cell?.value !== cell.row?.values["employerName"] && (
                          <div {...cell.getCellProps()}>
                            {cell.render("Cell")} ₪
                          </div>
                        )
                      );
                    })}
                  </div>
                </div>
              );
            // }
          })}
        </div>
      </div>
    </>
  );
}

function PensionValuesTable({ tableData }) {
  const { t } = useTranslation("common");

  const columns = React.useMemo(
    () => [
      {
        Header: "1",
        hideHeader: true,
        columns: [
          {
            Header: t("pensionValuesTable.employerName"),
            accessor: "employerName",
          },
          {
            Header: (
              <PensionValuesHeader
                imgSrc={tableDotStatus1}
                label={ t("pensionValuesTable.employeeSum")}
              />
            ),
            accessor: "employeeSum",
          },
          {
            Header: (
              <PensionValuesHeader
                imgSrc={tableDotStatus2}
                label={t("pensionValuesTable.employerSum")}
              />
            ),
            accessor: "employerSum",
          },
          {
            Header: (
              <PensionValuesHeader imgSrc={tableDotStatus3} label={t("pensionValuesTable.compensationSum")} />
            ),
            accessor: "compensationSum",
          },
        ],
      },
    ],
    []
  );

  return <Table columns={columns} data={tableData} />;
}

export default PensionValuesTable;
